import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { GtcService } from '@app/core/business/termsofsales/gtc.service';
import { ContextService } from '@app/core/service/context.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-terms-of-service-validation',
  templateUrl: './terms-of-service-validation.component.html',
  styleUrls: ['./terms-of-service-validation.component.scss']
})

export class TermsOfServiceValidationComponent {

  guid: string = '';
  pathCGV: string;

  constructor(private route: ActivatedRoute, private router: Router, public contextService: ContextService, private gtcService: GtcService, 
    private customerService: CustomerService, public toaster: ToastrService) { }

  ngOnInit() {
    this.guid = this.route.snapshot.paramMap.get('guid') || '';
    this.gtcService.GetDocumentsCGV("PRONATURAFRANCE", this.guid).subscribe(
      (blob: Blob) => {
        const objectURL = URL.createObjectURL(blob);
        this.pathCGV = objectURL;
      }, (error) => {
        console.error("❌ Erreur lors du chargement du PDF :", error);
      });
  }

   ngOnDestroy() {
    if (this.pathCGV) {
      URL.revokeObjectURL(this.pathCGV);
    }
  }

  public validateCGVByGuid(): void {
    this.customerService
      .validateTermsByGuid(
        "PRONATURAFRANCE",
        this.contextService.context.customerCode,
        this.guid
      )
      .subscribe(
        () => {
          this.contextService.validateTerms();
          this.toaster.success('dashboard.termsOfServiceValidated');
          this.router.navigate(['/login']);
        },
        error => {
          this.toaster.error(error);
        }
      );
  }

}
